export default __webpack_public_path__ + "static/media/Yenepoya-Logo-web.3662a93b.png";